import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import WhyChooseThisCar from "./component";

const mapStateToProps = ({
    carDetails: {
        content,
        config,
        cmsConfig
    }
}) => ({
    content,
    config,
    cmsConfig
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WhyChooseThisCar);
